import React, { ReactNode, useState } from 'react';
import { FormControl } from '@mui/material';
import { FrameHelperText, FrameLabel, FrameSurface } from './RichTextFieldFrame.styles';

export type RichTextFieldFrameProps = {
  label: ReactNode;
  error?: boolean;
  disabled?: boolean;
  helperText?: ReactNode;
  helperTextIsError?: boolean;
  children: ReactNode;
};

export const RichTextFieldFrame = ({
  label,
  error = false,
  disabled = false,
  helperText,
  helperTextIsError = false,
  children,
}: RichTextFieldFrameProps) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <FormControl fullWidth error={error}>
      <FrameLabel shrink error={error} disabled={disabled}>
        {label}
      </FrameLabel>
      <FrameSurface
        error={error}
        disabled={disabled}
        focused={isFocused}
        onFocus={() => !disabled && setIsFocused(true)}
        onBlur={() => !disabled && setIsFocused(false)}
      >
        {children}
      </FrameSurface>
      {helperText && (
        <FrameHelperText variant="caption" error={helperTextIsError} disabled={disabled}>
          {helperText}
        </FrameHelperText>
      )}
    </FormControl>
  );
};
